<template>
  <v-container class="pa-0">
    <v-layout>
      <v-calendar
        is-expanded
        :attributes="attributes"
        @dayclick="dayClicked"
        @update:fromPage='monthChanged'
        :theme-styles='themeStyles'
      >
      <!-- :disabled-dates="{ weekdays: [1, 7] }" -->
        
        <!-- Left and right arrow slot -->
        <!-- <template v-slot:header-left-button="slotProps">
          <v-icon color="white" @click="slotProps.movePrevMonth()">
            mdi-chevron-left
          </v-icon>
          <span> </span>
        </template>

        <template v-slot:header-right-button="slotProps">
          <v-icon color="white" @click="slotProps.moveNextMonth()">
            mdi-chevron-right
          </v-icon>
          <span> </span>
        </template> -->

        <!-- Header Slot -->
        <template v-slot:header-title="prop">
          {{prop.monthLabel}} {{prop.yearLabel}}
          <v-icon color="white">
            mdi-chevron-down
          </v-icon>
        </template>

      </v-calendar>
    </v-layout>
  </v-container>

</template>

<script>

import {
  mapState,
} from 'vuex'

export default {
  props: ['timesheetEntries'],
  data: () => {
    return {
      themeStyles: {
        weekdays: { // S M T ...
          color: '#4E4E4E',
          // fontWeight: '700',
          padding: '10px 10px 10px 10px',
          borderBottom: "1px solid #C8C9CC",
          backgroundColor: "white",
          // borderRadius: '25px'
          // border: "5px solid grey"
        },
        wrapper: { // the whole calendar
          // background: 'linear-gradient(to bottom right, red, blue)',
          // color: '#87CEEB',
          border: 'solid #d1d1d1 1px',
          // borderRadius: '10px'
          borderBottom: '1px solid #d1d1d1'
        },
        weeks: { // all the dates
          color: '#111111',
          fontWeight: '700',
          // backgroundColor: "white",
          // borderRadius: '10px',
          // border: "5px solid red"
        },
        header: { // Header with month and arros
          // backgroundColor: "#CCEADA",
          // borderRadius: '25px',
          // color: "blue",
          // margin: "10px",
          // padding: "1px",
          fontWeight: "700",
          // border: "1px solid blue",
          backgroundColor: '#1E618A',
          color: 'white',
          height: "70px"


          // fontStyle: 'bold',
          // borderBottom: "1px solid #D1D1D1",// + this.$vuetify.theme.pipefishLightBlue
        },
        headerTitle: {
          fontWeight: '700'
        },
        navHeader: { // month & year picker
          // background: "white",
          color: "#1E618A"
        },
        headerArrows: { // left and right arrows
          // border: "5px solid red",
          // fontSize: "40px"
          fontWeight: "bold"
        },
        dayCellNotInMonth: {
          display: "None",
          opacity: "0.3"
        },
        dayCell: { // individual dates
          // padding: "0px",
          marginBottom: "5px",
          
          // borderLeft: "0.5px solid #d3d3d3",
          // borderRight: "0.5px solid #d3d3d3"
        }
      },
      selectedDate: new Date()
    }
  },
  computed: {
    ...mapState('api', ['currentActivities']),
    attributes: function() {
      var result = [
        {
          key: 'Today',
          highlight: {
            backgroundColor: '#c3dfdb'
            // backgroundColor: this.$vuetify.theme.pipefishGreen,
          },
          contentStyle: {
            // color: '#fafafa',
            color: '#345853',
            // border: '2px solid #345853',
            fontWeight: '600'
          },
          dates: new Date(),
          popover: {
            label: 'Today\'s Date'
          }
        },
        {
          key: "Hover",
          dates: {},
          contentStyle({isHovered}) {
            return {
              backgroundColor: isHovered ? "#ddd": ""
            }
          }
        },
        { // Bold all the dates
          key: "Bold",
          dates: {},
          contentStyle: {
            fontWeight: '600',
          }
        },
        {
          key: 'SelectedDate',
          contentStyle: {
            border: 'solid grey 2px',
            borderRadius: '5px',
            fontWeight: '700'
          },
          dates: this.selectedDate
        },
        {
          key: "Weekends",
          contentStyle: {
            color: '#ABABAB'
          },
          dates: {weekdays: [1, 7]}
        }
      ]
      for(var entry in this.timesheetEntries) {
        var entryIndicator = {
          dot: {
            backgroundColor: `#${this.timesheetEntries[entry].client.Color}`
          },
          dates: this.timesheetEntries[entry].WorkedOn,
          popover: {
            label: this.timesheetEntries[entry].activity.IsLeave ? `${this.timesheetEntries[entry].activity.Name} for ${this.timesheetEntries[entry].HoursWorked}hrs` : `Worked ${this.timesheetEntries[entry].HoursWorked}hrs for ${this.timesheetEntries[entry].client.Name}`
          },
        }
        result.push(entryIndicator)
      }
      return result
    },
  },
  created() {
    /**
     * When the app is first launched, the timesheet view needs to know which
     * month to get all the dates for. So emit monthChanged event and pass in
     * today's date's month and year
     */
    this.$emit('monthChanged', {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1
    })
  },
  methods: {
    /* function which runs after one of the day is clicked
     *
     * @param day
     *    The day which was clicked
     */
    dayClicked(day) {
      this.selectedDate = day.date
      this.$emit("dayClicked", day)
    },
    /* function which runs after the current month is changed
     *
     * @param page
     *    which page the calendar is current displaying
     */
    monthChanged(page){
      // console.log(page)
      // console.log("Make a new GET request and fetch this months data")
      this.$emit('monthChanged', {
        year: page.year,
        month: page.month
      })
    },
  }

}
</script>

<style>

</style>
